// components/Celebration/ConfettiLayer.jsx
import React from "react";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";

const ConfettiLayer = ({ colors }) => {
  const { width, height } = useWindowSize();

  return (
    <Confetti
      width={width}
      height={height}
      numberOfPieces={250}
      recycle={false}
      colors={colors}
      gravity={0.25}
    />
  );
};

export default ConfettiLayer;
